<template>
  <div class="tags-autocomplete">
    <div id="tag-list-attach"></div>
    <v-autocomplete
      ref="tagsInputSearch"
      :items="tags"
      outlined
      focus
      dense
      chips
      multiple
      small-chips
      deletable-chips
      item-text="name"
      item-id="id"
      v-bind="resetProps"
      return-object
      :tabindex="tabindex"
      :search-input.sync="search"
      @keyup.enter="handleOnCreateNewTag"
      @update:search-input="updateSearch"
      @change="handleUpdate"
      attach="#tag-list-attach"
    >
      <template v-slot:item="{ item }">
        <div class="tag-auto-complete-item"> {{ item.name }} </div>
      </template>

      <template #no-data>
        <div class="tag-no-data-container">
          <Can do="create" :on="TAG_MODULE">
            {{ $t("no_tags_found_message") }}
          </Can>
          <Can not I="create" :on="TAG_MODULE">
            {{ $t("note_have_create_permission_message") }}
          </Can>
        </div>
      </template>
    </v-autocomplete>
    <v-overlay :absolute="true" :value="isLoading">
      <v-progress-circular :size="50" color="white" indeterminate></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import "./styles.scss";
import TagModule from "@/modules/customer/tags";
import { TagType } from "@/types/tags.type";
import { mapActions, mapGetters } from "vuex";

const AppTags = {
  name: "tags",

  data() {
    return {
      TAG_MODULE: TagModule.MODULE_NAME,
      search: "",
      tags: [],
      isLoading: false,
    };
  },

  props: {
    handleOnTagsUpdated: {
      type: Function,
    },
    tabindex: {
      type: Number,
      default: 0,
    },
  },

  mounted() {
    this.getAppTags();
  },

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },

    ...mapGetters({
      tagsList: "Tags/tags",
      tagSuccess: "Tags/success",
      tagMessage: "Tags/message",
      tagItem: "Tags/tag",
    }),
  },

  methods: {
    ...mapActions({
      getTags: "Tags/getTags",
      createTag: "Tags/create",
    }),

    /**
     * Get business tags list
     * @return {void}
     */
    async getAppTags() {
      await this.getTags();
      this.tags = [...this.tagsList];
    },

    /**
     * Update the serach value
     * @return {void}
     */
    updateSearch(search) {
      this.search = search;
    },

    /**
     * Handle on select
     * @param element {any}
     * @return {void}
     */
    handleUpdate(element) {
      this.handleOnTagsUpdated(element);
      this.$nextTick(()=>{
        this.search = "";
      })
    },

    /**
     * Handle on create new tag
     * @return {void}
     */
    async handleOnCreateNewTag() {
      this.isLoading = true;

      // prepare new tag
      const newTag = new TagModule({
        name: this.search,
      });

      // create new tag on the server
      await this.createTag(newTag);
      if (this.tagSuccess) {
        this.tags.push(this.tagItem);
        this.$refs.tagsInputSearch.selectItem(this.tagItem);
      }

      this.$nextTick(() => {
        this.search = "";
        this.isLoading = false;
      });
    },
  },
};

export default AppTags;
</script>
